export default __webpack_public_path__ + "static/media/E17.b2a22fb8.jpg";